<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, computed } from 'vue';
import CampoCheckboxBase from '@/components/v2/base/CampoCheckboxBase/CampoCheckboxBase.vue';
import UtilArray from '@/utils/UtilArray.mjs';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    headers: {
        type: Array,
        default: () => []
    },
    selecao: {
        type: String,
        default: 'nenhum'
    },
    dados: {
        type: Array,
        default: () => []
    },
    selecionados: {
        type: Array,
        default: () => []
    },
    itemKey: {
        type: String,
        default: 'id'
    }
});

const emits = defineEmits([
    'update:selecionados',
]);

/*==================================================================*/
/*================== SELECIONAR TODOS ==============================*/
/*==================================================================*/

const todosSelecionados = computed(() => {

    if(UtilArray.isEmpty(props.dados)){
        return false;
    }

    return UtilArray.containsAllBy(props.selecionados, props.dados, props.itemKey);

});

/*==================================================================*/
/*================== ALGUM SELECIONADO =============================*/
/*==================================================================*/

const algumSelecionado = computed(() => {

    return UtilArray.isNotEmpty(props.selecionados) && !todosSelecionados.value;

});

/*==================================================================*/
/*=============== ALTERA TODOS SELECIONADOS ========================*/
/*==================================================================*/

const alteraTodosSelecionados = (marcado) => {

    if(marcado){
        emits('update:selecionados', [...props.dados]);
        return;
    }

    emits('update:selecionados', []);

};

</script>

<template>

    <div class="c-tabela__header">

        <div
            class="c-header__cell"
            v-for="header in props.headers"
            :key="header.value"
        >

            <div
                v-if="header.value === 'selecao' && props.selecao === 'multiplo'"
                class="c-cell"
            >

                <CampoCheckboxBase
                    :value="todosSelecionados"
                    :indeterminate="algumSelecionado"
                    color="white"
                    dark
                    @change="alteraTodosSelecionados"
                ></CampoCheckboxBase>

            </div>

            <div v-else class="c-cell c-cell__text">
                {{ header.text }}
            </div>

        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*================== Header da Tabela ==============================*/
/*==================================================================*/

.c-tabela__header {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    background-color: #230bc1;
    color: #ffffff;
}

/*==================================================================*/
/*================== Célula do Header ==============================*/
/*==================================================================*/

.c-header__cell {
    padding: 14px 16px;
    font-weight: 700;
    font-size: 0.75rem;
}

.c-cell {
    display: flex;
    align-items: center;
    height: 100%;
}

</style>
